import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-end"
}
const _hoisted_2 = {
  key: 0,
  type: "button",
  class: "btn table-btn btn-outline-danger"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  colspan: "1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(`${_ctx.isDeleteRequested || _ctx.isEditRequested || _ctx.isViewRequested ? 'edit-row' : ''}`)
  }, [
    _createElementVNode("td", null, _toDisplayString(_ctx.note.title), 1 /* TEXT */),
    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.note.date)), 1 /* TEXT */),
    _createElementVNode("td", null, _toDisplayString(_ctx.note.userName), 1 /* TEXT */),
    (!_ctx.isDeleteRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          (_ctx.note.isCreatedUser)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_ctx.isEditRequested)
                  ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_2, _hoisted_4)), [
                      [_directive_tooltip, { title: 'Delete Note' }]
                    ])
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isDeleteRequested)
      ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
          _createVNode(_component_TablePrompt, {
            "ok-text": "delete",
            "is-in-progress": _ctx.isDeleteInProgress,
            ok: _ctx.deleteNote,
            cancel: _ctx.cancelDeleteNote
          }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}